export default "<div class=\"text-center\">\r\n      <img src=\"../../../../assets/images/loading.gif\">\r\n  </div> \r\n\r\n"